import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { selectSelectedTask, clearSelectedTask } from '../../slice/taskSlice'
import { useThemeColor } from '../../hooks/useThemeColor'
import { X, ChevronRight } from 'lucide-react'
import { useTranslation } from '../../i18n/LanguageContext'

import OverViewComp from './components/Overview'
import StandarQustions from './components/StandarQustions'
import SystemPrompts from './components/SystemPrompts'
import DefaultFiles from './components/DefaultFiles'
import TaskShortcuts from './components/TaskShortcuts'

const AddTasks = ({ setShowAddTask }) => {
  const [selectedTab, setSelectedTab] = useState('general')
  const dispatch = useDispatch()
  const { aispaceColor } = useThemeColor()
  const { t } = useTranslation()

  // Get the selected task from Redux store
  const selectedTask = useSelector(selectSelectedTask)

  useEffect(() => {
    if (selectedTask) {
      console.log('Selected Task:', selectedTask)
    }
  }, [selectedTask])

  const handleClose = () => {
    dispatch(clearSelectedTask())
    setShowAddTask(false)
  }

  const tabs = [
    { id: 'general', label: 'Allgemeine Einstellungen' },
    { id: 'questions', label: 'Standardfragen' },
    { id: 'ai-profile', label: 'KI-Profil' },
    { id: 'files', label: 'Standard-Dateien' },
    { id: 'overview', label: 'Projektübersicht' },
    { id: 'setup', label: 'Projekteinrichtung' },
    { id: 'shortcuts', label: 'Shortcuts' }
  ]

  const renderTabContent = () => {
    switch (selectedTab) {
      case 'general':
        return <OverViewComp />
      case 'questions':
        return <StandarQustions />
      case 'ai-profile':
        return <SystemPrompts />
      case 'files':
        return <DefaultFiles />
      case 'shortcuts':
        return <TaskShortcuts />
      default:
        return <OverViewComp />
    }
  }

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      {/* Breadcrumb */}
      <div className="flex items-center gap-2 px-6 py-4 text-[14px]">
        <button
          onClick={handleClose}
          className="flex items-center gap-2 text-[#6B7280] hover:text-[#374151] transition-colors"
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 4L4 8L12 12L20 8L12 4Z" />
            <path d="M4 12L12 16L20 12" />
            <path d="M4 16L12 20L20 16" />
          </svg>
          <span>{t('agentSettings.breadcrumbAgents')}</span>
        </button>
        <ChevronRight size={16} className="text-[#9CA3AF]" />
        <span className="text-[#111827] font-medium">{t('agentSettings.breadcrumbSettings')}</span>
      </div>

      {/* Agent Header Card */}
      <div className="mx-6 mb-6 bg-white rounded-xl border border-[#E5E7EB] p-6">
        <div className="flex items-start justify-between">
          <div>
            <h1 className="text-[20px] font-semibold text-[#111827] mb-1">
              {selectedTask?.name || t('agentSettings.agentFallback')}
            </h1>
            <p className="text-[14px] text-[#6B7280]">
              {selectedTask?.department || 'Benutzergruppe'}
            </p>
          </div>
          <button
            onClick={handleClose}
            className="p-2 hover:bg-[#F3F4F6] rounded-lg transition-colors"
          >
            <X size={20} className="text-[#6B7280]" />
          </button>
        </div>

        {/* Tabs */}
        <div className="flex items-center gap-1 mt-6 border-b border-[#E5E7EB] -mx-6 px-6">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setSelectedTab(tab.id)}
              className={`px-4 py-3 text-[14px] font-medium transition-colors relative ${
                selectedTab === tab.id
                  ? 'text-[#111827]'
                  : 'text-[#6B7280] hover:text-[#374151]'
              }`}
            >
              {tab.label}
              {selectedTab === tab.id && (
                <div
                  className="absolute bottom-0 left-0 right-0 h-[2px]"
                  style={{ backgroundColor: aispaceColor }}
                />
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="px-6 pb-8">
        {renderTabContent()}
      </div>
    </div>
  )
}

export default AddTasks
